/**
 * Table of contents and headings for the legal policy pages. Shopify prints the policy text without ids, so the second-level
 * headings get ids here and a list of jump links is built from them. Pages with fewer than three headings get none.
 * On desktop the list sits beside the text and stays in view; below 990px it is a collapsed "Inhoud" button.
 * The page reads fine without this script. No dependencies.
 */
const body = document.querySelector('.shopify-policy__body');
const tocLabel = document.querySelector('script[data-toc-label]')?.dataset.tocLabel || 'Contents';
const container = document.querySelector('.shopify-policy__container');

// The page title above the text is the only h1: a heading 1 inside the shop-authored text becomes a level 2 for assistive technology.
body?.querySelectorAll('h1').forEach((heading) => {
  heading.setAttribute('role', 'heading');
  heading.setAttribute('aria-level', '2');
});

// Shopify's own refund policy has no headings: its section titles are paragraphs that hold nothing but bold text.
// Turn those into real h2 elements (better for screen readers and for the list below) when the text has no h2.
if (body && !body.querySelector('h2')) {
  body.querySelectorAll('p').forEach((p) => {
    const text = p.textContent.trim();
    const only = p.children.length === 1 && p.firstElementChild.tagName === 'STRONG';
    if (!only || !text || text.length > 100 || text.endsWith(':') || p.firstElementChild.textContent.trim() !== text) return;
    const heading = document.createElement('h2');
    heading.textContent = text;
    p.replaceWith(heading);
  });
}

const headings = body ? [...body.querySelectorAll('h2')].filter((h) => h.textContent.trim()) : [];

if (container && headings.length >= 3) {
  const toc = document.createElement('details');
  toc.className = 'pt-toc';
  const summary = document.createElement('summary');
  summary.className = 'pt-toc__summary';
  summary.textContent = tocLabel;
  const nav = document.createElement('nav');
  nav.setAttribute('aria-label', tocLabel);
  const list = document.createElement('ul');
  list.className = 'pt-toc__list';

  headings.forEach((heading, index) => {
    heading.id = heading.id || `pt-policy-${index + 1}`;
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent.trim();
    item.append(link);
    list.append(item);
  });

  nav.append(list);
  toc.append(summary, nav);
  body.before(toc);

  // desktop: always open (the summary is only a label there); phones: collapsed until tapped
  const desktop = window.matchMedia('(min-width: 990px)');
  const sync = () => {
    toc.open = desktop.matches;
  };
  sync();
  desktop.addEventListener('change', sync);

  // mark the heading that is currently being read
  const links = new Map([...list.querySelectorAll('a')].map((a) => [a.getAttribute('href').slice(1), a]));
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        links.forEach((a) => a.removeAttribute('aria-current'));
        links.get(entry.target.id)?.setAttribute('aria-current', 'true');
      }
    },
    { rootMargin: '-96px 0px -70% 0px' }
  );
  headings.forEach((heading) => observer.observe(heading));
}
